module.exports = __webpack_public_path__ + "img/44.03a9292d.jpg";